import React from 'react';

import GenericField from './shared/GenericField';
import SelectManyInputContainer from './select_many/SelectManyInputContainer';

/**
 * Select between the given selectable options. "option" object: {string id, string name}.
 * @param {string} [label] Label description for field input.
 * @param {string} [icon] Icon next to input, see ./shared/FormatHelpers.js/getIconClassName for available icons.
 * @param {list<option>} [initialValue] Field value (list of options).
 * @param {list<option>} [options] Selectable options.
 * @param {function} [handleSave] [async list<option>=>{bool success, string message}] Save changes / return error message.
 */
const SelectMany = ({ label, icon: iconName, initialValue, options, handleSave: syncChanges }) => {
    return (
        <GenericField>
            {label}
            <SelectManyInputContainer {...{ iconName, initialValue, options, syncChanges }} />
        </GenericField>
    );
};

export default SelectMany;
